import { h } from 'preact'
import { MandatsamlingSvg } from '../../../shared/MandatsamlingSvg/MandatsamlingSvg'
import { MandatTableItem, sumAntall } from '../../../shared/mandater'
import { getKommunestyreConfig } from '../../../shared/MandatsamlingSvg/configurations'
import { message, Message } from '../../../../../lib/intl/Message'
import { Geografi } from '../../../../domain'
import { MandatsamlingLegend } from '../../../shared/MandatsamlingLegend/MandatsamlingLegend'
import styles from '../Mandatfordeling.css'

type Props = {
  items: MandatTableItem[]
  geografi: Geografi
  type: 'kommunestyre' | 'fylkesting'
  hideLegend?: boolean
}

export function EnkelMandatfordeling(props: Props) {
  const { items, geografi, type, hideLegend } = props
  const navn = geografi.navn

  if (items.length > 0) {
    return (
      <div class={styles.enkelMandatfordeling}>
        <MandatsamlingSvg
          items={items}
          config={getKommunestyreConfig(sumAntall(items))}
          title={message(`${type}-grafikk`)}
          partinavn={true}
        />
        {hideLegend ? null : (
          <MandatsamlingLegend items={items} config={getKommunestyreConfig(sumAntall(items))} />
        )}
      </div>
    )
  }

  return (
    <p>
      <Message id={`${type}-ingen-resultat`} values={{ navn }} />
    </p>
  )
}
